import { render, staticRenderFns } from "./sidebar_preferences.vue.js?vue&type=template&id=40edd981!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=template&id=40edd981"
import script from "./sidebar_preferences.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=script&lang=js"
export * from "./sidebar_preferences.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40edd981')) {
      api.createRecord('40edd981', component.options)
    } else {
      api.reload('40edd981', component.options)
    }
    module.hot.accept("./sidebar_preferences.vue.js?vue&type=template&id=40edd981!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=template&id=40edd981", function () {
      api.rerender('40edd981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/sidebar_preferences.vue"
export default component.exports